import axios from 'axios'
import { camelCase } from '../../modules/string_converter'
import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../modules/mutations.js'

function castAttributesForCamelCase(obj) {
  const castData = {}
  for (const [key, value] of Object.entries(obj)) {
    castData[camelCase(key)] = value
  }
  return castData
}

export const companiesTestimonials = {
  namespaced: true,
  state: {
    data: null,
    meta: null,
    formValues: {},
    loading: false,
    filteredCount: 0,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readTextsSuccess(state, payload) {
      state.data = payload.data.map(data => {
        let castData = castAttributesForCamelCase(data.attributes)
        return castData
      })
      state.meta = castAttributesForCamelCase(payload.meta)
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
    setValuesForFilter(state, payload) {
      state.filteredCount = payload.meta.total_count
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
  },
  actions: {
    readTexts({ commit }, {company_uuid, params}) {
      commit('prepareConnect')
      axios
        .post('/api/companies/' + company_uuid + '/testimonials.json', params )
        .then(res => {
          commit('readTextsSuccess', res.data)
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          console.log(err)
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readTextsForFilter({ commit }, {company_uuid, params}) {
      axios
        .post('/api/companies/' + company_uuid + '/testimonials.json', params )
        .then(res => {
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          console.log(err)
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    }
  }
}
